import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../ui/Button';
import { Container } from '../ui/Container';
import { cn } from '../../lib/utils';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Solutions',
    href: '/solutions'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Case Studies',
    href: '/case-studies'
  }, {
    name: 'Resources',
    href: '/resources'
  }, {
    name: 'About',
    href: '/about'
  }];
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'bg-dashboard-bg/95 backdrop-blur-md border-b border-dashboard-border shadow-lg' : 'bg-dashboard-bg/80 backdrop-blur-sm border-b border-dashboard-border/50')} data-id="element-367">
      <Container data-id="element-368">
        <div className="flex items-center justify-between py-4" data-id="element-369">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 z-50 group" data-id="element-370">
            <div className="h-10 w-10 bg-tech-blue rounded flex items-center justify-center" data-id="element-371">
              <span className="text-dashboard-bg font-black text-xl" data-id="element-372">L</span>
            </div>
            <div className="flex flex-col" data-id="element-373">
              <span className="text-lg font-bold tracking-tight text-dashboard-text leading-none" data-id="element-374">
                LAI Solutions
              </span>
              <span className="text-xs text-dashboard-muted font-medium" data-id="element-375">
                Engineering Systems
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-376">
            {navLinks.map(link => <Link key={link.name} to={link.href} className="text-sm font-semibold text-dashboard-text hover:text-tech-blue transition-colors" data-id="element-377">
                {link.name}
              </Link>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-378">
            <a href="tel:+61892266399" className="flex items-center gap-2 text-sm font-medium text-dashboard-muted hover:text-tech-blue transition-colors" data-id="element-379">
              <Phone className="w-4 h-4" data-id="element-380" />
              <span className="hidden xl:inline" data-id="element-381">+61 8 9226 6399</span>
            </a>
            <Button variant="cta" size="default" className="font-semibold" data-id="element-382">
              Book a Discovery Call
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden z-50 p-2 text-dashboard-text hover:text-tech-blue transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-383">
            {isMobileMenuOpen ? <X size={24} data-id="element-384" /> : <Menu size={24} data-id="element-385" />}
          </button>
        </div>
      </Container>

      {/* Mobile Menu */}
      <div className={cn('fixed inset-0 bg-dashboard-bg z-40 flex flex-col pt-24 px-6 lg:hidden transition-transform duration-300 ease-in-out', isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full')} data-id="element-386">
        <nav className="flex flex-col space-y-6" data-id="element-387">
          {navLinks.map(link => <Link key={link.name} to={link.href} className="text-lg font-semibold text-dashboard-text border-b border-dashboard-border pb-4 hover:text-tech-blue transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-388">
              {link.name}
            </Link>)}
          <a href="tel:+61892266399" className="flex items-center gap-2 text-lg font-semibold text-dashboard-text pb-4 hover:text-tech-blue transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-389">
            <Phone className="w-5 h-5" data-id="element-390" />
            +61 8 9226 6399
          </a>
          <Button className="w-full mt-4" variant="cta" size="lg" data-id="element-391">
            Book a Discovery Call
          </Button>
        </nav>
      </div>
    </header>;
}